module.exports = __webpack_public_path__ + "img/comercializador.95ec78ad.png";